import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "@mui/lab/LoadingButton";
import { Button, TextField, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import { useTranslation } from "react-i18next";

interface ResendOtpModalProps {
  open: boolean;
  email: string;
  isLoading: boolean;
  taskId: string;
  processId: string;
  handleClose: () => void;
  sendForm: (requestId: string, taskId: string) => void;
  setEmail: (s: string) => void;
}

export default function ResendOtpModal({
  open,
  handleClose,
  sendForm,
  processId,
  taskId,
  email,
  isLoading,
  setEmail
}: ResendOtpModalProps): React.JSX.Element {

  const emailValue = email || "";
  const { t } = useTranslation();

  return (
    <Modal
      aria-describedby="modal-modal-description"
      aria-labelledby="modal-modal-title"
      onClose={handleClose}
      open={open}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "75%",
          backgroundColor: "background.paper",
          boxShadow: 24,
          p: 3,
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <Typography fontSize={16} fontWeight={500} sx={{ width: '500px'}}>
          {t("signature.resendOtpTitle")}
        </Typography>
        <Typography fontSize={14} fontWeight={400} sx={{ marginBottom: '20px'}}>
          {t("signature.resendOtpDescription")}
        </Typography>

        <TextField
          label={t("signature.additionalEmailLabel")}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          placeholder={t("signature.emailPlaceholder")}
          slotProps={{ inputLabel: { shrink: true } }}
          style={{ width: "100%", marginTop: "16px" }}
          value={emailValue}
        />
        <LoadingButton
          loading={isLoading}
          onClick={() => {
            sendForm(processId, taskId);
          }}
          style={{ width: "100%", marginTop: "16px" }}
          variant="contained"
        >
          {t("signature.resendOtpButton")}
        </LoadingButton>
        <Button
          onClick={handleClose}
          style={{ width: "100%", marginTop: "16px" }}
        >
          {t("signature.returnToDocuments")}
        </Button>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 0,
            top: 0,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Modal>
  );
}
